import {omit} from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {findParentTags, findTagNestingLevel} from '../../helpers/models/tagHelpers';
import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {TagModel} from '../../models/api/tagModel';
import {AppState} from '../../store/appState';
import {ResourceMap} from '../../store/appTypes';
import {SettingsTagNameCell} from './settingsTagNameCell';

/*
 * Props.
 */

interface SettingsTagNameCellContainerProps {
  value: TagModel;
  searchTagsIdMap: ResourceMap<TagModel>;
  parentTagId?: number;
}

/*
 * Selectors.
 */

function getTag(_state: AppState, props: SettingsTagNameCellContainerProps) {
  return props.value;
}

function getParentTagId(_state: AppState, props: SettingsTagNameCellContainerProps) {
  return props.parentTagId;
}

function getTags(_state: AppState, props: SettingsTagNameCellContainerProps) {
  return props.searchTagsIdMap;
}

function makeGetNestingLevel() {
  return createSelector([getTag, getTags, getParentTagId], (tag, tags, parentTagId) =>
    findTagNestingLevel(omit(tags, parentTagId || 0), tag),
  );
}

function makeGetParentTags() {
  return createSelector([getTag, getTags], (tag, tags) => findParentTags(tags, tag));
}

const mapStateToProps = makeMapStateToProps<SettingsTagNameCellContainerProps>()(() => ({
  nestingLevel: makeGetNestingLevel(),
  parentTags: makeGetParentTags(),
}));

/*
 * Redux.
 */

export const SettingsTagNameCellContainer = connect(mapStateToProps)(SettingsTagNameCell);
